
export default {
  name: 'AppIconCoachMarkPc',
  props: {
    iconSize: { type: Number, default: 160 }
  }
};
